<template>
  <div
    class="audit-log-item px-5 py-4 rounded-[12px] bg-white border border-slate-100 flex flex-row justify-between"
  >
    <div class="py-0.5 flex flex-row items-center gap-3">
      <div
        class="icon w-10 h-10 flex justify-center items-center rounded-[8px]"
        :class="getAuditLogIconBgClass(item)"
      >
        <img :src="getAuditLogIcon(item)" class="w-5 h-5" alt="" />
      </div>
      <div>
        <div class="mb-2 text-primary">
          {{ generateLogText(item) }}
        </div>
        <div class="flex flex-row items-center text-sm text-secondary gap-2">
          <span class="date-item">
            {{
              messageTimestamp(
                item.created_at,
                $root.$i18n.locale === 'en' ? 'MMM dd, yyyy' : 'dd MMM yyyy'
              )
            }}
          </span>
          <span class="text-[#A3A3A3]">•</span>
          <span class="date-item">
            {{ messageTimestamp(item.created_at, 'HH:mm') }}
          </span>
        </div>
      </div>
    </div>
    <div class="flex flex-col justify-between items-end">
      <div class="flex flex-row gap-3 items-start flex-1">
        <span
          class="border bg-mute-bg-01 text-mute-text-01 border-mute-stroke-01 px-2 py-1 text-sm rounded-[8px]"
        >
          #{{ item.auditable_id }}
        </span>
        <span
          class="border px-2 py-1 text-sm rounded-[8px]"
          :class="getAuditLogColorClass(item)"
        >
          {{ $t(`AUDIT_LOGS.${getAuditableTypeLabel(item)}`) }}
        </span>
      </div>
      <div class="text-slate-400 text-xs">
        {{ item.remote_address }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  getAuditableTypeLabel,
  getAuditLogColorClass,
  getAuditLogIcon,
  getAuditLogIconBgClass,
} from './helpers';
import {
  generateTranslationPayload,
  generateLogActionKey,
} from 'dashboard/helper/auditlogHelper';
import timeMixin from 'dashboard/mixins/time';

export default {
  mixins: [timeMixin],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      agentList: 'agents/getAgents',
    }),
  },
  methods: {
    getAuditableTypeLabel,
    getAuditLogColorClass,
    getAuditLogIcon,
    getAuditLogIconBgClass,
    generateLogText(auditLogItem) {
      const translationPayload = generateTranslationPayload(
        auditLogItem,
        this.agentList
      );
      const translationKey = generateLogActionKey(auditLogItem);

      if (auditLogItem.comment === 'role:update') {
        translationPayload.role_name =
          auditLogItem.audited_changes?.role_name || '';
      }

      return this.$t(translationKey, translationPayload);
    },
  },
};
</script>

<style lang="scss" scoped>
/* Tag badge color variants */
.audit-tag--blue {
  @apply bg-[#2563EB0A] text-[#2563EB] border-[#2563EB];
}
.audit-tag--orange {
  @apply bg-[#BE41000A] text-[#BE4100] border-[#BE4100];
}
.audit-tag--purple {
  @apply bg-[#7C3AED0A] text-[#7C3AED] border-[#7C3AED];
}
.audit-tag--green {
  @apply bg-[#0283130A] text-[#028313] border-[#028313];
}
.audit-tag--red {
  @apply bg-[#D81A6E0A] text-[#D81A6E] border-[#D81A6E];
}
.audit-tag--gray {
  @apply bg-mute-bg-01 text-mute-text-01 border-mute-stroke-01;
}

/* Icon background color variants */
.audit-icon--green {
  @apply bg-green-100;
}
.audit-icon--blue {
  @apply bg-blue-100;
}
.audit-icon--orange {
  @apply bg-yellow-100;
}
.audit-icon--red {
  @apply bg-red-100;
}
.audit-icon--purple {
  @apply bg-purple-100;
}
.audit-icon--gray {
  @apply bg-neutral-100;
}
</style>
